import React, { useState } from 'react';
import { Button } from '../shared/Button';
interface LoginScreenProps {
  onLogin: () => void;
  onBack: () => void;
}
export const LoginScreen = ({
  onLogin,
  onBack
}: LoginScreenProps) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({
    email: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const validate = () => {
    let isValid = true;
    const newErrors = {
      email: '',
      password: ''
    };
    if (!email.trim()) {
      newErrors.email = 'Email is required';
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = 'Email is invalid';
      isValid = false;
    }
    if (!password) {
      newErrors.password = 'Password is required';
      isValid = false;
    } else if (password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate()) {
      setIsLoading(true);
      // Simulate API call with timeout
      setTimeout(() => {
        setIsLoading(false);
        onLogin();
      }, 1000);
    }
  };
  return <div className="flex flex-col h-full min-h-screen p-6 bg-white" data-id="element-20">
      <div className="mb-6" data-id="element-21">
        <button onClick={onBack} className="text-gray-500 mb-4 text-sm" data-id="element-22">
          ← Back
        </button>
        <div className="mb-5" data-id="element-23">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9qPx53UyjZGfyvkE6gkvqL/01_FitFuel_Logo.png" alt="FitFuel Logo" className="h-14 mb-5" data-id="element-24" />
          <h1 className="text-xl font-bold text-gray-900 mb-1" data-id="element-25">
            Welcome back!
          </h1>
          <p className="text-gray-600 text-sm" data-id="element-26">
            Log in to continue your fitness journey
          </p>
        </div>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4 mb-6" data-id="element-27">
        <div data-id="element-28">
          <label htmlFor="email" className="block text-xs font-medium text-gray-700 mb-1" data-id="element-29">
            Email
          </label>
          <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" className={`w-full p-2.5 border ${errors.email ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm`} tabIndex={1} data-id="element-30" />
          {errors.email && <p className="mt-1 text-xs text-red-500" data-id="element-31">{errors.email}</p>}
        </div>
        <div data-id="element-32">
          <div className="flex justify-between mb-1" data-id="element-33">
            <label htmlFor="password" className="block text-xs font-medium text-gray-700" data-id="element-34">
              Password
            </label>
            <button type="button" className="text-xs text-blue-600 hover:text-blue-800" tabIndex={3} data-id="element-35">
              Forgot password?
            </button>
          </div>
          <input type="password" id="password" value={password} onChange={e => setPassword(e.target.value)} className={`w-full p-2.5 border ${errors.password ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm`} tabIndex={2} data-id="element-36" />
          {errors.password && <p className="mt-1 text-xs text-red-500" data-id="element-37">{errors.password}</p>}
        </div>
        <Button type="submit" variant="primary" size="lg" fullWidth disabled={isLoading} tabIndex={4} className="text-sm py-2.5" data-id="element-38">
          {isLoading ? <div className="flex items-center justify-center" data-id="element-39">
              <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-40">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-41"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-42"></path>
              </svg>
              Logging in...
            </div> : 'Log In'}
        </Button>
      </form>
      <div className="mt-4 text-center" data-id="element-43">
        <p className="text-gray-600 text-xs" data-id="element-44">
          Don't have an account?{' '}
          <button onClick={onBack} className="text-blue-600 font-medium hover:text-blue-800" tabIndex={5} data-id="element-45">
            Sign up
          </button>
        </p>
      </div>
    </div>;
};